import React from 'react';

const Section1 = ()=>{

    return(
        <div className="presidentMessage">
            <div className="row messageWrapper">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-wrap">
                    <div className="imageContainer">
                        <img src="./images/presidentMessage/president.jpg" className="shadow" alt="" />
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-wrap">
                    <div className="content">
                        <p>
                            Muhamad Saad Munawar Khan (MBA’ 06), the newly elected president of the Suleman Dawood School of Business Luminites Association, envisions to create a strong positive impact as a partner to his alma mater. He wants the association to serve as a support system to the institution and to the students by offering the experience and expertise of the alumni in identifying the needs and expectations of the outside world to create powerful industry-academia linkages.
                        </p>
                        <p> 
                            A LUMS alumnus, Saad M. Khan completed his BSc in Computer Science in 2003 followed by an MBA with a major in marketing in 2006. While at SDSB, Saad was also an exchange student at the Copenhagen Business School where he studied marketing and strategy. After graduating from SDSB, Saad worked for two years at Procter & Gamble and then moved to Pepsi Co in 2008 where he is currently Director Franchise, Sales Capability and National Key Accounts, Pakistan & Afghanistan. A marketing professional, Saad is no stranger to building communities, creating linkages and bridging gaps. In his role as president, Saad is committed to further developing the SDSB Luminities Association to serve as a compass that connects the community, especially in these difficult times. 
                        </p>
                        <p> 
                            “Saad’s vibrant and creative approach will appeal to the SDSB students and faculty who are looking for opportunities to connect with the industry,” said Dr. Muhammad Adeel Zaffar, SDSB Associate Dean External Relations.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default React.memo(Section1);